import { useEffect } from 'react';

import { useActiveFieldStore } from '~/common/componentMapper/QuestionExtraction/activeFieldStore';

export default function useSetPdfBoundingBoxes() {
  const { setActiveField } = useActiveFieldStore();

  useEffect(() => {
    return () => {
      window.postMessage(
        {
          type: 'pdfCitation',
          payload: [],
        },
        globalThis.location.origin,
      );
    };
  }, []);

  //INFO: sets pdf citation/bounding boxes and changes background of QuestionExtraction component on focus

  return (boundingBoxes, fieldName) =>
    function () {
      setCitation(boundingBoxes || null);
      setActiveField(fieldName || '');
    };

  function setCitation(citation) {
    window.postMessage(
      {
        type: 'pdfCitation',
        payload: [citation],
      },
      globalThis.location.origin,
    );
  }
}
